


































































import { Vue, Component } from 'vue-property-decorator'
import type { OfertaRelacionadaDoProduto } from '@/models'
import { formatarMoeda } from '@/shareds/formatadores'

@Component
export default class DialogoDeOfertasRelacionadas extends Vue {
	readonly imagemPadrao = 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png'
	readonly formatarMoeda = formatarMoeda

	mostra = false
	nomeItemSelecionado = ''
	ofertasSelecionadas: OfertaRelacionadaDoProduto[] = []
	carregandoIdx: number | null = null
	adicionados: string[] = []
	skuSelecionado: string | null = null

	mostrar(nomeItem: string, ofertas: OfertaRelacionadaDoProduto[], skuSelecionado: string | null) {
		this.nomeItemSelecionado = nomeItem
		this.ofertasSelecionadas = ofertas
		this.skuSelecionado = skuSelecionado
		this.mostra = true
	}

	fechar() {
		this.mostra = false
		this.carregandoIdx = null
		this.adicionados = []
		this.nomeItemSelecionado = ''
		this.ofertasSelecionadas = []
		this.skuSelecionado = ''
	}

	marcarAdicionado(produtoId: string) {
		if (!this.adicionados.includes(produtoId)) {
			this.adicionados.push(produtoId)
		}
	}

	clicarAdicionar(idx: number, oferta: OfertaRelacionadaDoProduto) {
		this.carregandoIdx = idx
		this.$emit('adicionar', oferta)
	}

	finalizarCarregamento() {
		this.carregandoIdx = null
	}

	get colSize(): number {
		const n = this.ofertasSelecionadas.length
		if (n === 1) return 12
		if (n === 2) return 6
		return 4
	}

	badgeLabel(idx: number): string {
		return ['Mais levado', 'Combina', 'Combina'][idx] || ''
	}

	badgeColor(idx: number): string {
		return ['amber darken-1', 'green darken-1', 'green darken-1'][idx] || 'grey'
	}

	badgeIcon(idx: number): string {
		return ['mdi-fire', 'mdi-check', 'mdi-check'][idx] || ''
	}
}
